module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//tiger_5_2.png?v=44c5295d";